module.exports = __webpack_public_path__ + "img/flight.926ee8fa.svg";